import { ChatChannel, getClientIdByChatChannel } from 'helpers/chat-channels';
import { isTextNativeChannelClientId } from 'helpers/text-native-channels';

import { type IAgentBot } from './interfaces';

export const filterHiddenIntegrationBots = (bot: IAgentBot): boolean => {
  const facebookMessengerClientId = getClientIdByChatChannel(ChatChannel.FacebookMessenger);
  const HIDDEN_INTEGRATION_BOTS_OWNER_CLIENT_IDS = [facebookMessengerClientId] as const;

  return (
    !bot.ownerClientId ||
    (!HIDDEN_INTEGRATION_BOTS_OWNER_CLIENT_IDS.includes(bot.ownerClientId) &&
      !isTextNativeChannelClientId(bot.ownerClientId))
  );
};
